const TELEMETRY_URL = process.env.REACT_APP_TELEMETRY_URL || 'https://telemetry.selwynevents.com';
const INGEST_KEY = process.env.REACT_APP_TELEMETRY_KEY || '';
const APP = 'ticketing';
const FLUSH_INTERVAL_MS = 5000;
const FLUSH_BATCH_SIZE = 20;

let _tenantId = null;
let _tenantSlug = null;
let _userId = null;
let _sessionId = null;
let _queue = [];
let _timer = null;

function _generateSessionId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

function _scheduleFlush() {
  if (_timer) return;
  _timer = setTimeout(flush, FLUSH_INTERVAL_MS);
}

export async function flush() {
  clearTimeout(_timer);
  _timer = null;
  if (_queue.length === 0 || !INGEST_KEY) return;
  const batch = _queue.splice(0);
  try {
    await fetch(`${TELEMETRY_URL}/api/v1/ingest/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Ingest-Key': INGEST_KEY },
      body: JSON.stringify({ events: batch }),
      keepalive: true,
    });
  } catch {
    // fire and forget — swallow errors silently
  }
}

export function init({ tenantId, tenantSlug, userId } = {}) {
  if (tenantId !== undefined) _tenantId = tenantId;
  if (tenantSlug !== undefined) _tenantSlug = tenantSlug;
  if (userId !== undefined) _userId = userId;
  _sessionId = _sessionId || _generateSessionId();
}

export function track(eventType, screen = null, properties = {}) {
  if (!INGEST_KEY) return;
  _queue.push({
    app: APP,
    tenant_id: _tenantId,
    tenant_slug: _tenantSlug,
    user_id: _userId,
    session_id: _sessionId,
    event_type: eventType,
    screen,
    properties,
  });
  if (_queue.length >= FLUSH_BATCH_SIZE) {
    flush();
  } else {
    _scheduleFlush();
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
}
